module.exports = __webpack_public_path__ + "static/media/视频截图_3.246cbcc8.png";